/** 按指定小数位四舍五入，避免 JS 浮点误差。默认两位小数。 */
export function roundMoney(amount: number, decimals = 2): number {
  if (!Number.isFinite(amount)) return 0;
  const factor = 10 ** decimals;
  return Math.round((amount + Number.EPSILON) * factor) / factor;
}

/** 日元等无辅币币种按整数；其余币种保留两位小数。 */
export function getCurrencyDecimals(currency?: string): number {
  if (currency === 'JPY') return 0;
  return 2;
}

export function roundMoneyByCurrency(
  amount: number,
  currency?: string,
): number {
  return roundMoney(amount, getCurrencyDecimals(currency));
}

export function thousands(data?: number | string, separator = ',') {
  if (data === 0 || data === '0') return '0';
  if (!data) return '';

  const num = Number(data);
  if (!Number.isFinite(num)) return '';

  const rounded = roundMoney(num, 2);
  const sign = rounded < 0 ? '-' : '';
  const [integerPart, fractionPart] = Math.abs(rounded).toFixed(2).split('.');
  const grouped = integerPart.replace(
    /\d(?=(\d{3})+(?!\d))/g,
    `$&${separator}`,
  );

  if (fractionPart === '00') {
    return `${sign}${grouped}`;
  }

  return `${sign}${grouped}.${fractionPart.replace(/0$/, '')}`;
}

/**
 * 积分实际从订单扣掉的原币种金额。
 * 用「总额 - 优惠 - 券 - 应付」反推，避免日元×汇率四舍五入后大于订单总额。
 */
export function getPointsDeductionActualCurrency({
  totalAmountActualCurrency,
  promotionAmountActualCurrency,
  couponAmount,
  payAmountActualCurrency,
  actualCurrencyRate,
}: {
  totalAmountActualCurrency?: number | null;
  promotionAmountActualCurrency?: number | null;
  couponAmount?: number | null;
  payAmountActualCurrency?: number | null;
  actualCurrencyRate?: number | null;
}): number {
  const couponActual = roundMoney(
    (couponAmount || 0) * (actualCurrencyRate ?? 1),
  );
  return Math.max(
    0,
    roundMoney(
      (totalAmountActualCurrency || 0) -
        (promotionAmountActualCurrency || 0) -
        couponActual -
        (payAmountActualCurrency || 0),
    ),
  );
}
